import { get, post } from './fetch';

export interface Category {
  id: number;
  name: string;
  imgSource: string;
}

export const categoryListTree = async (): Promise<Category[]> => {
  try {
    const categories = await get<Category[]>('/category/list-tree');
    return categories;
  } catch (error) {
    throw new Error('Error occurred while fetching categories');
  }
};

export const categoryListTreeAdmin = async (): Promise<Category[]> => {
  try {
    const categories = await get<Category[]>('/category/list-tree?showAll=true');
    return categories;
  } catch (error) {
    throw new Error('Error occurred while fetching categories');
  }
};

export const getListTreeForReports = async (includeMonthlyTests = false): Promise<any[]> => {
  try {
    const query = includeMonthlyTests ? '?includeMonthlyTests=true' : '';
    const categories = await get<any[]>(`/category/list-tree-for-reports${query}`);
    return categories;
  } catch (error) {
    throw new Error('Error occurred while fetching categories for reports');
  }
};

export const createCategory = async (category: Category): Promise<void> => {
  try {
    await post('/categories', category);
  } catch (error) {
    throw new Error('Error occurred while creating the category');
  }
};

export const categoryDelete = async (id: number): Promise<{ status: string }> => {
  try {
    const categories = await get<{ status: string }>('/category/delete?id=' + id);
    return categories;
  } catch (error) {
    throw new Error('Error occurred while fetching categories');
  }
};

export const categoryBreadcrumbs = async (id: number): Promise<Category[]> => {
  try {
    return await get<Category[]>('/category/breadcrumbs?id=' + id);
  } catch (error) {
    throw new Error('Error occurred while fetching categories');
  }
};
